import { render } from "./oactivity.vue?vue&type=template&id=067d5b8d&scoped=true"
const script = {}

import "./oactivity.vue?vue&type=style&index=0&id=067d5b8d&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067d5b8d"]])

export default __exports__